<template>
  <div class="task-manager-top bg-light h-100 d-flex flex-column" :class="{'fullscreen-mode': fullscreen}">
    <div class="py-1 px-4 d-flex w-100 align-items-center" style="border-bottom: 1px solid #ccc">
      <h4 class="bold">Liste des tâches</h4>
      <div class="ml-auto">
        <a v-if="fullscreen" href="javascript:;" @click="fullscreen = false"><i class="icon-size-actual"></i></a>
        <a v-else href="javascript:;" @click="fullscreen = true"><i class="icon-size-fullscreen"></i></a>
      </div>
    </div>
    <div class="d-flex task-manager-container w-100 flex-grow-1" style="height: 173px;" :class="{'task-selected' : selectedTask !== null, 'is-mobile' : isMobile}">

      <!-- Panneau de gauche -->
      <div class="position-relative task-manager-left-panel">

        <!-- Encadré gris avec filtres. -->
        <div class="bg-grey py-3 px-4 d-flex task-manager-filters" style="flex-wrap: wrap;">

          <div class="filter-element d-flex align-items-center">
            <label style="width: 90px; min-width: 90px">Mots clés:</label>
            <input type="text" class="form-control input-sm mx-1" placeholder="Mots clés..." v-model="taskFilters.keywords" @change="fetchTasks">
          </div>

          <div class="filter-element d-flex align-items-center">
            <label style="width: 60px; min-width: 60px">Ordre:</label>
            <select v-model="taskFilters.order_column" class="form-control input-sm mx-1" @change="fetchTasks">
              <option value="task_creation_datetime">Date de création</option>
              <option value="task_deadline_date">Date d'échéance</option>
              <option value="task_start_date">Date de début</option>
              <option value="task_remind_date">Date de rappel</option>
              <option value="project_number">Projet</option>
              <option value="task_name">Nom de la tâche</option>
            </select>
            <button class="btn btn-sm blue" v-if="taskFilters.order_direction == 'DESC'" @click="taskFilters.order_direction = 'ASC'; fetchTasks()"><i class="fa fa-arrow-down"></i></button>
            <button class="btn btn-sm blue" v-else-if="taskFilters.order_direction == 'ASC'" @click="taskFilters.order_direction = 'DESC'; fetchTasks()"><i class="fa fa-arrow-up"></i></button>
          </div>

          <div class="filter-element d-flex align-items-center">
            <label style="width: 90px; min-width: 90px">États:</label>
            <multiselect v-model="taskFilters.state_id" :options="stateOptions" :popupWidth="'250px'" class="btn btn-default input-sm" :width="'200px'" @hidden="fetchTasks" :optionTemplate="optionStateTemplate" />
          </div>

          <!-- <div class="d-flex align-items-center">
            <label>Catégorie de tâche:</label>
            <select v-model="taskFilters.category_id" class="form-control input-sm mx-1" @change="fetchTasks">
              <option :value="null">Toutes les catégories</option>
              <option v-for="(category, index) in categories" :key="index" :value="category.task_category_id">{{category.task_category_name}}</option>
            </select>
          </div> -->

          <div class="filter-element d-flex align-items-center">
            <label style="width: 60px; min-width: 60px">Projet:</label>
            <div>
              <select2 ref="taskFiltersProject" class="mx-1" placeholder="Tous les projets" :endpoint="projectSelect2Endpoint" @selected="projectSelected" @clear="projectSelected(null)" />
            </div>
          </div>

          <div class="filter-element d-flex align-items-center" v-if="options.showUserFilter">
            <label style="width: 90px; min-width: 90px">Utilisateur:</label>
            <div>
              <select2 class="mx-1" placeholder="Tous les utilisateurs" :endpoint="userSelect2Endpoint" :value="selectedUserFilter" @selected="userSelected" @clear="userSelected(null)" />
            </div>
          </div>

          <div class="filter-element d-flex align-items-center" v-if="options.showUserFilter">
            <label style="width: 60px; min-width: 60px">Assigné:</label>
            <div class="pl-2">
              <input type="checkbox" value="1" v-model="taskFilters.assigned" @change="fetchTasks">
            </div>
            <label style="width: 90px; min-width: 90px">Distribution:</label>
            <div class="pl-2">
              <input type="checkbox" value="1" v-model="taskFilters.distribution" @change="fetchTasks">
            </div>
          </div>

        </div>

        <!-- Ajout de tâche. -->
        <div class="px-4 py-2" style="border-bottom: 1px solid #ccc">
          <div v-if="!showAddTaskForm">
            <button class="btn blue btn-sm" @click="addNewTask"> <i class="fa fa-plus"></i> Ajouter une tâche</button>
            <button class="btn blue btn-sm" @click="fetchTasks" :disabled="loadingTasks"> <i class="fa fa-refresh"></i> Rafraîchir </button> <img v-if="loadingTasks" :src="spinnerSVG" style="height: 24px; margin-right: 10px;">
          </div>
          <div v-else>
            <div class="d-flex w-100">
              <input ref="add-task-name-input" type="text" class="form-control input-sm flex-grow-1" placeholder="Nom de la tâche..." v-model="addTaskForm.task_name" @keydown.enter="saveNewTask(addTaskForm)" @keydown.esc="showAddTaskForm = false" :disabled="savingTask">
              <select2 ref="taskAddProjectSelect" v-model="addTaskSelectedProject" class="mx-1" placeholder="Projet..." style="width: 250px" :endpoint="projectSelect2Endpoint" @selected="taskAddProjectSelect" />
              <button class="btn btn-sm blue" @click="saveNewTask(addTaskForm)" :disabled="savingTask"><i class="fa fa-check"></i></button>
            </div>
            <div class="font-red" v-if="addTaskError != null">
              {{addTaskError}}
            </div>
          </div>
        </div>

        <!-- Liste des tâches... -->
        <div style="overflow-y: auto">
          <div v-if="loadedTasks.length == 0 && !loadingTasks">
            <div class="text-center p-3 font-grey-gallery">Aucune tâches à afficher</div>
          </div>
          <div v-else>
            <table class="w-100">
              <tbody>
                <tr v-for="(task, index) in loadedTasks" :key="index" class="task-manager-task" :class="{'selected': task == selectedTask, 'task-unread':!task.task_read}" @click="selectTask(task)">
                  <!-- <button class="btn grey btn-sm"><i class="fa fa-user-plus"></i></button> -->

                  <!-- <td class="pl-4 py-2" style="white-space: nowrap; width: 1%">
                    <div class="py-1 px-3 text-center" style="border-radius: 100px" :style="{color: task.task_category_font_color, backgroundColor: task.task_category_background_color}">{{task.task_category_name}}</div>
                  </td> -->

                  <td class="pl-4 py-2" style="white-space: nowrap; width: 1%">
                    <div v-for="(assignee, index) in task.assignees" :key="index" class="task-assignee" :style="{backgroundColor: assignee.user_background_color}">
                      {{assignee.user_initials}}
                    </div>
                  </td>

                  <td class="py-2 pl-2">
                    <div class="task-name">{{task.task_name}}</div>
                    <div style="font-size: 11px">{{task.project_number}} • {{task.project_name}}</div>
                    <div style="font-size: 11px">
                      <span v-if="task.task_deadline_date != null" class="mr-2 deadline-indicator" :class="{'deadline-danger': daysBeforeDeadline(task) < options.redIndicatorDays, 'deadline-warning': daysBeforeDeadline(task) < options.yellowIndicatorDays && daysBeforeDeadline(task) >= options.redIndicatorDays}">
                        <i class="fa fa-clock-o"></i> {{daysBeforeDeadline(task)}} jour{{daysBeforeDeadline(task) == 1 ? '' : 's'}}
                      </span>
                      <span v-if="task.comment_count > 0" class="mr-2"><i class="fa fa-comment-o"></i> {{task.comment_count}}</span>
                      <span v-if="task.file_count > 0" class="mr-2"><i class="fa fa-paperclip"></i> {{task.file_count}}</span>
                      <span v-if="task.task_progress > 0" class="mr-2"><i class="fa fa-percent"></i> {{task.task_progress}}</span>
                      <span v-if="task.task_reminder" class="mr-2 deadline-indicator deadline-danger">
                        <i class="fa fa-bell"></i> Rappel
                      </span>
                      <span v-if="task.task_mentions > 0" class="mr-2 deadline-indicator deadline-danger">
                        @ {{task.task_mentions}}
                      </span>
                    </div>
                  </td>
                  <td style="white-space: nowrap; width: 1%; font-size: 11px; text-align: right; font-family: monospace" class="pl-1 pr-2">
                    <div v-if="task.task_start_date != null">Début: {{task.task_start_date}}</div>
                    <div v-if="task.task_deadline_date != null" :class="{'font-red': daysBeforeDeadline(task) <= options.redIndicatorDays}">Échéance: {{task.task_deadline_date}}</div>
                  </td>
                  <td class="bold font-blue pr-4 py-2" style="white-space: nowrap; width: 1%">{{task.task_state_name}}</td>
                  <td class="task-unread-indicator"></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="loadingTasks">
            <div class="text-center p-3 font-grey-gallery"><img :src="spinnerSVG" style="height: 30px; margin-right: 10px;"> Chargement des tâches...</div>
          </div>
        </div>

        <div style="width: 2px; top: 0; right: 0;" class="bg-grey h-100 position-absolute"></div>
      </div>

      <!-- Panneau de droite -->
      <div class="task-manager-right-panel">
        <div v-if="selectedTask !== null" class="h-100">
          <task-details 
            :task="selectedTask"
            :user="user"
            :states="states"
            :categories="categories"
            @close="unselectTask" 
            @deleted="taskDeleted"
            @toggleread="toggleTaskRead"
            ref="task-detail"
            v-if="!loadingSelectedTask"
          />
          <div v-else class="h-100 d-flex align-items-center justify-content-center">
            <img :src="spinnerSVG" style="height: 30px; margin-right: 10px;"> Chargement de la tâche...
          </div>
        </div>
        <div v-else class="h-100 d-flex align-items-center justify-content-center">
          Veuillez sélectionner une tâche
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import toastr from 'toastr';
import Select2 from '../Select2.vue';
import TaskDetails from './TaskDetails.vue';  
import Multiselect from '../MultiSelect.vue';

export default {
  components: { TaskDetails, Select2, Multiselect },
  name: "task-manager",
  props: {
    user: {
      type: Object,
      required: true
    },
    states: {
      type: Array,
      required: true
    },
    categories: {
      type: Array,
      required: true
    },
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    defaultSelectedTask: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showAddTaskForm: false,
      savingTask: false,
      loadingTasks: false,
      loadingSelectedTask: false,
      firstLoading: true,
      addTaskForm: {
        task_name: "",
        task_project_id: null,
        task_category_id: 0
      },
      addTaskSelectedProject: undefined,
      taskFilters: {
        keywords: "",
        project_id: null,
        state_id: [],
        category_id: null,
        user_id: this.user.user_id,
        order_direction: "ASC",
        order_column: "task_deadline_date",
        included_task_ids: [],
        assigned: true,
        distribution: true
      },
      loadedTasks: [],
      selectedTask: null,
      isMobile: false,
      addTaskError: null,
      selectedUserFilter: {
        id: this.user.user_id,
        text: this.user.user_name,
      },
      options: {
        redIndicatorDays: 5,
        yellowIndicatorDays: 10
      },
      fullscreen: false
    }
  },
  async mounted () {
    let that = this;

    for (const key in this.params) {
      this.options[key] = this.params[key];
    }

    this.taskFilters.state_id = this.states.filter((t) => {
      return t.task_state_active == "1";
    }).map(t => t.task_state_id);

    moment.locale("fr");

    $(window).on("resize", (ev) => {
      let width = ev.target.innerWidth;
      that.isMobile = width < 767;
    })

    $(document).on("click", ".label-task", async (e) => {
      e.preventDefault();
      let taskid = $(e.target).data("task-id");
      let task = that.loadedTasks.find(t => t.task_id == taskid);
      if(task !== undefined){
        that.selectTask(task);
      } else {
        that.taskFilters.included_task_ids.push(taskid);
        await that.fetchTasks(false);
        let task = that.loadedTasks.find(t => t.task_id == taskid);
        if(task !== undefined){
          that.selectTask(task);
        } else {
          toastr.error("Vous n'avez pas accès à cette tâche ou celle-ci n'existe pas.");
        }
      }
    });

    WS.leave("task-list");
    WS.join("task-list", (data) => {

      let task = null;

      switch(data.action){
        case "post-comment":
          if(that.selectedTask !== null && data.task_id == that.selectedTask.task_id){
            that.selectedTask.comments.unshift(data.comment);
            that.selectedTask.total_comments++;
            that.selectedTask.loaded_comment_count++;
            this.$nextTick(() => {
              window.applyAdvancedFormatDetails();
            })  
          }
          task = that.loadedTasks.find(e => e.task_id == data.task_id);
          if(task != null){
            task.task_read = false;
            task.comment_count++;
            if(data.mentions.indexOf(parseInt(this.user.user_id)) !== -1){
              task.task_mentions++;
            }
          }
          break;
        case "delete-comment":
          if(this.selectedTask?.task_id == data.task_id){
            let ix = this.selectedTask.comments.findIndex(a => a.task_comment_id == data.task_comment_id);
            this.selectedTask.comments.splice(ix, 1);
            this.$nextTick(() => {
              window.applyAdvancedFormatDetails();
            })  
          }
          task = that.loadedTasks.find(e => e.task_id == data.task_id);
          if(task != null){
            task.comment_count--;
          }
          break;
        case "update-task":
          task = that.loadedTasks.find(e => e.task_id == data.task_id);
          if(task != null){
            Object.assign(task, data.task);
          }
          break;
        case "create-task":
          that.fetchTasks();
          break;
        case "delete-task":
          let index = that.loadedTasks.findIndex(e => e.task_id == data.task_id);

          if(index !== -1){
            that.loadedTasks.splice(index, 1);
          }

          if(that.selectedTask !== null && data.task_id === parseInt(that.selectedTask.task_id)){
            that.selectedTask = null;
            toastr.info("La tâche sélectionné a été supprimée")
          }

          break;
        case "add-assignee":
          task = this.loadedTasks.find(e => e.task_id == data.task_id);
          if(task != null){
            task.assignees.push({
              task_user_id: data.task_user_id,
              user_name: data.user_name,
              user_background_color: data.user_background_color,
              user_initials: data.user_initials,
            })
          }
          break;
        case "remove-assignee":
          task = this.loadedTasks.find(e => e.task_id == data.task_id);
          if(task != null){
            let ix = task.assignees.findIndex(a => a.task_user_id == data.task_user_id);
            task.assignees.splice(ix, 1);
          }
          break;
        case "add-distributor":
          task = this.loadedTasks.find(e => e.task_id == data.task_id);
          if(task != null){
            task.distributors.push({
              task_user_id: data.task_user_id,
              user_name: data.user_name,
              user_background_color: data.user_background_color,
              user_initials: data.user_initials,
            })
          }
          break;
        case "remove-distributor":
          task = this.loadedTasks.find(e => e.task_id == data.task_id);
          if(task != null){
            let ix = task.distributors.findIndex(a => a.task_user_id == data.task_user_id);
            task.distributors.splice(ix, 1);
          }
          break;
        case "add-file":
          if(this.selectedTask?.task_id == data.task_id){
            this.selectedTask.files.push({
              task_file_id: data.task_file_id,
              task_file_task_id: data.task_id,
              task_file_title: data.task_file_title,
              task_file_task_comment_id: data.task_file_task_comment_id,
              task_file_attachment_datetime: data.task_file_attachment_datetime,
              task_file_mime: data.task_file_mime
            })
          }
          task = that.loadedTasks.find(e => e.task_id == data.task_id);
          if(task != null){
            task.file_count++;
          }
          break;
        case "delete-file":
          if(this.selectedTask?.task_id == data.task_id){
            let ix = this.selectedTask.files.findIndex(a => a.task_file_id == data.task_file_id);
            this.selectedTask.files.splice(ix, 1);
          }
          task = that.loadedTasks.find(e => e.task_id == data.task_id);
          if(task != null){
            task.file_count--;
          }
          break;
        case "read-reset":
          let task = this.loadedTasks.find(t => t.task_id == data.task_id);
          if(task != null && this.user.user_id != data.exclude_user_id){
            task.task_read = false;
          }
          break;
      }

    });

    this.$nextTick(() => {
      let width = window.innerWidth;
      that.isMobile = width < 767;
    })
    
    await this.fetchTasks();

    if(this.defaultSelectedTask != 0){
      let task = this.loadedTasks.find(t => t.task_id == this.defaultSelectedTask);
      this.selectTask(task);
    }
  },
  computed: {
    spinnerSVG() {
      return `${window.baseUrl}assets/global/img/spinner.svg`;
    },
    projectSelect2Endpoint() {
      return `${window.baseUrl}task/select2/task_project_id`;
    },
    userSelect2Endpoint() {
      return `${window.baseUrl}task/select2/task_user_id`;
    },
    unreadTasks() {
      return this.loadedTasks.filter(e => !e.task_read);
    },
    daysBeforeDeadline() {
      return (task) => {
        return task.task_deadline_date == null ? null : (moment(task.task_deadline_date).diff(moment(), 'days')+1);
      }
    },
    stateOptions() {
      return this.states.map((opt) => {
        return {
          value: opt.task_state_id,
          label: opt.task_state_name,
        }
      })
    }
  },
  methods: {
    async fetchTasks(clear_included_task_ids = true) {
      if(clear_included_task_ids){
        this.taskFilters.included_task_ids = [];
      }

      this.loadingTasks = true;
      try {
        let response = await $.post(`${window.baseUrl}task/searchjson`, this.taskFilters);
        for (const task of response) {
          task.total_comments = 0;
          task.loaded_comment_count = 0;
          task.loaded_history_count = 0;
        }
        this.loadedTasks.splice(0, this.loadedTasks.length, ...response);
        this.firstLoading = false;
      } catch (err) {
        toastr.error("Une erreur s'est produite lors de l'obtention des tâches.");
        console.error(err);
      }
      this.loadingTasks = false;
    },
    async loadDetails(task) {
      try {
        let response = await $.post(`${window.baseUrl}task/getonejson`, {id: task.task_id});
        Object.assign(task, response);
      } catch (err) {
        toastr.error("Une erreur s'est produite lors de l'obtention des détails de la tâche.");
        console.error(err);
      }
    },
    async selectTask(task) {
      this.loadingSelectedTask = true;
      this.selectedTask = task;
      await this.loadDetails(task);
      this.markTaskRead(this.selectedTask, true);
      this.loadingSelectedTask = false;
      this.$nextTick(() => {
        this.$refs["task-detail"].update();
        window.applyAdvancedFormatDetails();
      })
    },
    taskDeleted(task) {
      let index = this.loadedTasks.findIndex(e => e.task_id == task.task_id);
      this.loadedTasks.splice(index,1);
      this.selectedTask = null;
    },
    toggleTaskRead(task) {
      this.markTaskRead(task, !task.task_read)
    },
    unselectTask() {
      this.selectedTask = null;
    },
    taskAddProjectSelect(selected) {
      this.addTaskForm.task_project_id = selected === null ? null : selected.id;
    },
    projectSelected(selected) {
      this.taskFilters.project_id = selected === null ? null : selected.id;
      this.fetchTasks();
    },
    userSelected(selected) {
      this.selectedUserFilter = selected;
      this.taskFilters.user_id = selected === null ? null : selected.id;
      this.fetchTasks();
    },
    async markTaskRead(task, read) {
      try {
        let response = await $.post(`${window.baseUrl}task/markread`, {task_id: task.task_id, read: read?1:0});
        task.task_read = read;
        if(read){
          task.task_reminder = false;
          task.task_mentions = 0;
        }
      } catch(err) {
        toastr.error(`Une erreur s'est produite au moment de marquer la tâche come ${read ? 'lue' : 'non lue'}.`);
        console.error(err);
      }
    },
    addNewTask(){
      this.addTaskError = null;
      this.showAddTaskForm = true;
      this.addTaskForm.task_name = "";
      this.addTaskForm.task_category_id = 1;
      this.addTaskForm.task_project_id = this.taskFilters.project_id ?? null;
      this.$nextTick(() => {
        this.$refs["add-task-name-input"].focus();
        if(this.addTaskForm.task_project_id != null){
          let selectedProject = this.$refs["taskFiltersProject"].selectedItem;
          this.addTaskSelectedProject = {
            id: this.addTaskForm.task_project_id,
            text: selectedProject.text
          }
        }
      })
    },
    async saveNewTask(form) {
      
      if(form.task_name.length == 0){
        this.addTaskError = "Le nom de la tâche est obligatoire."
        return;
      } else if(form.task_project_id == null){
        this.addTaskError = "Un projet doit être sélectionné."
        return;
      } else {
        this.addTaskError = null;
      }

      this.savingTask = true;

      let data = {
        task_name: form.task_name,
        task_category_id: form.task_category_id,
        task_project_id: form.task_project_id,
        task_state_id: 1
      };
      
      try {
        let response = await $.post(`${window.baseUrl}task/add/save`, {form: Object.serialize(data), accept: "json"});
        this.showAddTaskForm = false;
        this.loadedTasks.unshift(response.data);
        this.selectTask(this.loadedTasks[0]);
        toastr.success("La tâche a été créée avec succès!");
      } catch(err) {
        toastr.error("Une erreur s'est produite lors de la création d'une nouvelle tâche.");
        console.error(err);
      }
      this.savingTask = false;
    },
    optionStateTemplate(index, label, value, element) {

      let assigned_count = 0;
      let distribution_count = 0;
      for(let state of this.states) {
        assigned_count += state.assigned_count;
        distribution_count += state.distribution_count;
      }

      console.log(index);

      let msg = "";

      if(index == -1) {
        msg = `
          <table>
            <tbody>
              <td style="min-width: 150px">Tout sélectionner</td>
              <td style="min-width: 40px; text-align:center;">${assigned_count}</td>
              <td style="min-width: 40px; text-align:center;">${distribution_count}</td>
            </tbody>
          </table>
        `;
      } else {
        msg = `
          <table>
            <tbody>
              <td style="min-width: 150px">${label}</td>
              <td style="min-width: 40px; text-align:center;">${this.states[index].assigned_count}</td>
              <td style="min-width: 40px; text-align:center;">${this.states[index].distribution_count}</td>
            </tbody>
          </table>
        `;
      }

      return msg;
    }
  },
}
</script>

<style lang="scss" scoped>
.task-manager-top {
  &.fullscreen-mode {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 9999;
    background-color: #fff;
  }
}

.task-manager-task {
  border-bottom: 1px solid #ccc;
  cursor: pointer;

  &:hover {
    background-color: #eee;
  }

  &.selected {
    background-color: rgb(158, 197, 255);
  }
}

.task-manager-container {
  .task-manager-left-panel {
    display: flex;
    flex-direction: column;
    width: 50%;
  }
  .task-manager-right-panel {
    width: 50%;
  }

  &.is-mobile {

    &:not(.task-selected) {
      .task-manager-left-panel {
        width: 100%;
      }
      .task-manager-right-panel {
        display: none;
      }
    }

    &.task-selected {
      .task-manager-left-panel {
        display: none;
      }
      .task-manager-right-panel {
        width: 100%;
      }
    }

  }
}

.task-manager-filters {
  display: flex;
  flex-wrap: wrap;

  .filter-element {
    width: 50%;
    padding: 3px 0;

    &>label{
      width: 120px;
      min-width: 120px;
      text-align: right;
      margin: 0;
      line-height: 30px;
      font-size: 12px;
    }
  }

}

.deadline-indicator {
  color: green;
  border-radius: 30px;

  &.deadline-warning {
    color: black;
    background-color: yellow;
    padding: 0 3px;
  }

  &.deadline-danger {
    color: white;
    background-color: red;
    font-weight: bold;
    padding: 0 3px;
  }
}

.task-assignee {
  color: white;
  padding: 3px;
  font-size: 11px;
  border-radius: 20px;
  text-align: center;
  margin: 0 2px;
  display: inline-block;
  width: 21px;
}
  
.task-unread-indicator {
  width: 5px;
}

.task-unread {
  .task-name {
    font-weight: bold;
    color: #356adc;
  }

  .task-unread-indicator {
    background-color: #356adc;
  }
}
</style>